export default {
  common: {
    reset: "Reset",
    refresh: "Refresh",
    edit: "Edit",
    delete: "Delete",
    create: "Create",
    update: "Update",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    search: "Search",
    all: "All",
    yes: "Yes",
    no: "No",
    unnamed: "Unnamed",
  },
  app: {
    title: "JSONBin.io Data Management",
    description: "Manage and edit your JSONBin.io Bins",
    tokenRequired: "Please set JSONBin.io Token first to start using",
  },
  tokenPrompt: {
    title: "API Token Required",
    description: "To use this tool to manage your JSONBin.io Bins, please get and set your Master Key first. After logging in or signing up for a JSONBin.io account, you can get it on the API Keys page.",
    getToken: "Get API Token",
    visitSite: "Visit JSONBin.io",
  },
  token: {
    title: "JSONBin.io Token",
    notSet: "Token not set",
    edit: "Edit",
    delete: "Delete",
    placeholder: "Enter your JSONBin.io Master Key",
    saveSuccess: "Token saved successfully",
    deleteSuccess: "Token deleted",
    deleteConfirm: "Are you sure you want to delete the Token? You will need to set it again to use.",
    deleteTitle: "Confirm Delete",
  },
  binTable: {
    title: "Bin List",
    createNew: "Create New Bin",
    name: "Name",
    binId: "Bin ID",
    createdAt: "Created At",
    private: "Private",
    operations: "Operations",
    namePlaceholder: "Search name",
    idPlaceholder: "Search Bin ID",
    dateRangeLabel: "Created At",
    privateLabel: "Private",
    deleteConfirm: "Are you sure you want to delete this Bin?",
    deleteSuccess: "Deleted successfully",
    loadFailed: "Failed to load",
    deleteFailed: "Failed to delete",
    tokenWarning: "Please set Token first",
    makePrivate: "Make Private",
    makePublic: "Make Public",
    togglePrivateSuccess: "Toggled successfully",
    togglePrivateFailed: "Failed to toggle",
  },
  binEditor: {
    createTitle: "Create New Bin",
    editTitle: "Edit Bin",
    nameLabel: "Bin Name (Optional)",
    namePlaceholder: "Enter Bin name (ASCII characters only)",
    dataLabel: "JSON Data",
    dataPlaceholder: 'Enter JSON data, e.g: {"key": "value"}',
    privateLabel: "Private",
    privateTooltip: "Private Bins require Token to access, public Bins can be accessed by anyone",
    createSuccess: "Created successfully",
    updateSuccess: "Updated successfully",
    saveFailed: "Failed to save",
    loadFailed: "Failed to load",
    tokenWarning: "Please set Token first",
    jsonError: "JSON format error, please check",
    nameAsciiError: "Name can only contain ASCII characters (Chinese not supported)",
    format: "Format",
    formatSuccess: "Formatted successfully",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit Fullscreen",
  },
  theme: {
    normal: "Normal",
    dark: "Dark",
    tech: "Future",
  },
};
